export default __webpack_public_path__ + "static/media/demonologisthead.139f2fbf.png";